import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/deslike"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0263 11L8.30376 15.1053C7.93323 15.6641 7.3074 16 6.63697 16L6.5197 16C5.96741 16 5.5197 15.5523 5.5197 15L5.5197 11L2.00202 11C0.581292 11 -0.386432 9.56014 0.150154 8.24463L2.44346 2.62232C2.59696 2.24599 2.96296 2 3.36939 2L11.0263 2L11.0263 11ZM13.0264 11L15.0264 11C15.5787 11 16.0264 10.5523 16.0264 10L16.0264 3C16.0264 2.44772 15.5787 2 15.0264 2L13.0264 2L13.0264 11Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Deslike16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Deslike16 = createIcon(IconComponent);